// ✅ 이미지 데이터 목록
const imagesData = [
  { key: "경신", src: "강.png", reason: "끊임없는 흐름과 안정" },
  { key: "경인", src: "강철 검.png", reason: "결단과 용기" },
  { key: "계묘", src: "고요한 호수.png", reason: "침착함과 안정" },
  { key: "신미", src: "구름.png", reason: "평화로움과 고요의 상징" },
  { key: "정사", src: "구슬.png", reason: "가치와 희망" },
  { key: "신축", src: "금속 방패.png", reason: "보호와 방어" },
  { key: "을미", src: "꽃다발.png", reason: "행복과 축복" },
  { key: "계미", src: "꽃잎.png", reason: "아름다움과 조화" },
  { key: "갑인", src: "나무 가지.png", reason: "풍요와 번영" },
  { key: "갑술", src: "나무 잎.png", reason: "새로운 시작과 성장" },
  { key: "갑신", src: "나무 줄기.png", reason: "성장의 기운" },
  { key: "정미", src: "나침반.png", reason: "미래의 방향성" },
  { key: "갑자", src: "네잎클로버.png", reason: "행운의 상징" },
  { key: "무자", src: "도자기.png", reason: "전통과 뿌리를 상징" },
  { key: "을축", src: "도토리.png", reason: "성장과 힘의 상징" },
  { key: "기축", src: "돌탑.png", reason: "안정과 강인함" },
  { key: "경오", src: "말발굽.png", reason: "행운과 전진의 상징" },
  { key: "기사", src: "매듭 팔찌.png", reason: "지혜와 장수의 상징" },
  { key: "경진", src: "메탈릭 용.png", reason: "강인함과 권위" },
  { key: "병진", src: "모래시계.png", reason: "시간의 중요성" },
  { key: "계유", src: "물방울.png", reason: "순수와 생명의 상징" },
  { key: "신유", src: "바람개비.png", reason: "변화의 중심" },
  { key: "기유", src: "바위.png", reason: "단단함의 상징" },
  { key: "계사", src: "번데기.png", reason: "변화와 도전" },
  { key: "을사", src: "벼.png", reason: "풍요로움의 상징" },
  { key: "정유", src: "별.png", reason: "기회를 상징" },
  { key: "을해", src: "복주머니.png", reason: "복과 풍요의 상징" },
  { key: "병신", src: "불꽃.png", reason: "활기와 에너지" },
  { key: "병자", src: "불꽃놀이.png", reason: "활기와 즐거움" },
  { key: "임자", src: "빛나는 물결.png", reason: "새로운 시작" },
  { key: "경자", src: "빛나는 보석.png", reason: "빛나는 기운" },
  { key: "무인", src: "산의 정상.png", reason: "성취와 안정감" },
  { key: "계축", src: "새벽의 별.png", reason: "성장의 아름다움" },
  { key: "기묘", src: "새싹.png", reason: "생명력의 상징" },
  { key: "무신", src: "성벽.png", reason: "전통의 아름다움" },
  { key: "신사", src: "수호 부적.png", reason: "보호와 안전의 상징" },
  { key: "임인", src: "숲.png", reason: "자연과 고요" },
  { key: "을묘", src: "싱그러운 잎.png", reason: "밝은 변화" },
  { key: "갑진", src: "씨앗.png", reason: "성장의 상징" },
  { key: "을유", src: "아침 해.png", reason: "새로운 시작" },
  { key: "기미", src: "열매 바구니.png", reason: "풍요의 상징" },
  { key: "신해", src: "은반지.png", reason: "행운과 희망" },
  { key: "신묘", src: "은빛 초.png", reason: "희망과 순수의 상징" },
  { key: "정축", src: "작은 등불.png", reason: "미래를 밝히는 희망" },
  { key: "임오", src: "잔잔한 물결.png", reason: "부드럽고 차분한 기운" },
  { key: "무오", src: "천칭.png", reason: "조화와 균형" },
  { key: "갑오", src: "초록빛 새싹.png", reason: "새로운 시작의 기운" },
  { key: "정묘", src: "촛불.png", reason: "희망과 은은한 에너지" },
  { key: "병술", src: "캠프파이어.png", reason: "가족의 따뜻함" },
  { key: "병인", src: "태양.png", reason: "뜨거운 열정과 생명력" },
  { key: "임진", src: "파도.png", reason: "끊임없는 흐름" },
  { key: "경술", src: "팬던트.png", reason: "부와 재물" },
  { key: "임술", src: "푸른 바다.png", reason: "새로운 시작의 힘" },
  { key: "계해", src: "풍요로운 잔.png", reason: "행복의 씨앗" },
  { key: "기해", src: "항아리.png", reason: "토대와 기초" },
  { key: "정해", src: "홍등.png", reason: "풍요와 밝음" },
  { key: "병오", src: "화로.png", reason: "뜨거운 열정" },
  { key: "무술", src: "황금 열쇠.png", reason: "새로운 문을 여는 열쇠" },
  { key: "임신", src: "황금 코인.png", reason: "부와 재물의 상징" },
  { key: "무진", src: "황금용.png", reason: "기운과 번영 상징" },
];

const ResultImage = ({ imageKey }: { imageKey: string }) => {
  // ✅ 랜덤 이미지 데이터 선택
  const randomImage = imagesData.filter((img) => img.key === imageKey)[0];

  return (
    <div className="result-image">
      <img src={`/60image/${randomImage.src}`} alt={randomImage.key} />
      <p className="symbol">{randomImage.src.replace(".png", "")}</p>
      <p>{randomImage.reason}</p>
    </div>
  );
};

export default ResultImage;
